import React, { ReactElement } from 'react'
import { Box, Flex, Text, theme } from '@mindfulchefuk/design-system'
import { RecipeStatLowCarbon } from '@mindfulchefuk/features/Onboarding/components/RecipeStats/RecipeStatLowCarbon'
import { RecipeFeedback } from '@mindfulchefuk/features/Recipes/interfaces'
import { RecipeRating } from '@mindfulchefuk/features/Recipes/components/RecipeCardWithClaims/RecipeCardWithClaimsStats/RecipeRating/RecipeRating'
import { RecipeModalStat } from './RecipeModalStat/RecipeModalStat'
import { RecipeModalPriceStat } from './RecipeModalStat/RecipeModalPriceStat/RecipeModalPriceStat'

type TRecipeModalStatsGroup = {
  carbonRatingLow?: boolean
  cookingTime: number
  feedback?: RecipeFeedback
  prepTime: number
  price: number
  pricePerPerson: number
  productId: string
  productName: string
}

export const RecipeModalStatsGroup = ({
  carbonRatingLow = false,
  cookingTime,
  feedback,
  prepTime,
  price,
  pricePerPerson,
  productId,
  productName,
}: TRecipeModalStatsGroup): ReactElement => {
  return (
    <Box mb={20}>
      <Flex direction="row" mb={20}>
        {prepTime > 0 && (
          <RecipeModalStat title="Prep Time" content={`${prepTime} MIN`} />
        )}
        <RecipeModalStat title="Total Time" content={`${cookingTime} MIN`} />
        <RecipeModalPriceStat
          title="Price"
          price={price}
          pricePerPerson={pricePerPerson}
        />
      </Flex>
      {feedback && (
        <Flex direction="row">
          <Text variant="body-md" color={theme.colors['pepper-500']} mr={4}>
            You rated this recipe
          </Text>
          <RecipeRating
            feedback={feedback}
            productId={productId}
            productName={productName}
            starColor="pepper-200"
          />
        </Flex>
      )}
      {carbonRatingLow && <RecipeStatLowCarbon variant="details" />}
    </Box>
  )
}
